import React, { FC } from 'react';
import { UilCheck } from '@iconscout/react-unicons';
import { IVisitTemplate } from '../../types';

interface IVisitSelectionStepProps {
  visitTemplates: IVisitTemplate[];
  selectedVisits: number[];
  trialName: string;
  onVisitToggle: (index: number) => void;
}

export const VisitSelectionStep: FC<IVisitSelectionStepProps> = ({
  visitTemplates,
  selectedVisits,
  trialName,
  onVisitToggle,
}) => (
  <>
    <div className="multi-appointment-info-box">
      <strong>{trialName}</strong> requires {visitTemplates.length} visit
      {visitTemplates.length !== 1 ? 's' : ''} per patient. Select the visits you want to schedule
      now.
    </div>

    <section className="form-section">
      <h2 className="form-title title-md is-underlined">Trial Visit Template</h2>
    </section>

    <section className="form-section">
      <table className="multi-appointment-visit-table">
        <thead>
          <tr>
            <th style={{ width: 60 }}>Visit</th>
            <th>Type</th>
            <th>Duration</th>
            <th>Interval</th>
            <th>MD Required</th>
            <th style={{ width: 80 }}>Schedule</th>
          </tr>
        </thead>
        <tbody>
          {visitTemplates.map((visit, index) => (
            <tr key={index}>
              <td>
                <div className="multi-appointment-visit-num">{index + 1}</div>
              </td>
              <td>
                <strong>{visit.type || visit.name || `Visit ${index + 1}`}</strong>
                {visit.name && visit.name !== visit.type && (
                  <div style={{ fontSize: 12, color: '#667085' }}>{visit.name}</div>
                )}
              </td>
              <td>{visit.duration} min</td>
              <td>
                {(() => {
                  if (index === 0) return <span style={{ color: '#868fa0' }}>— (first visit)</span>;
                  if (visit.date) return `${visit.date} days`;
                  return <span style={{ color: '#868fa0' }}>Not configured</span>;
                })()}
              </td>
              <td>{visit.md ? 'Yes' : 'No'}</td>
              <td>
                <div className="field-control">
                  <label className="checkbox" onClick={() => onVisitToggle(index)}>
                    <input
                      type="checkbox"
                      className="checkbox-input visually-hidden"
                      checked={selectedVisits.includes(index)}
                      onChange={() => onVisitToggle(index)}
                    />
                    <div className="checkbox-mark">
                      {selectedVisits.includes(index) && <UilCheck size={16} />}
                    </div>
                  </label>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <div style={{ marginTop: 12, fontSize: 12, color: '#667085' }}>
        {selectedVisits.length} of {visitTemplates.length} visits selected for scheduling
      </div>
    </section>
  </>
);
